import React from "react";
import { Module } from "@tvg/amplitude/modules/raceCell/types";
import { Props } from "./types";
import TracksSection from "../TracksSection";
import CollapsibleWrapper from "../CollapsibleWrapper";
import { buildQaLabel } from "../../utils";
import { LIST } from "../../utils/constants";

const FavoriteTracksList = ({
  title,
  tracks,
  onTrackClickHandler,
  qaLabel = ""
}: Props) => (
  <TracksSection title={title} qaLabel={buildQaLabel([qaLabel, LIST])}>
    {tracks.map((track) => (
      <CollapsibleWrapper
        track={track}
        onTrackClickHandler={onTrackClickHandler}
        qaLabel={buildQaLabel([qaLabel, LIST])}
        module={Module.FAVORITES}
      />
    ))}
  </TracksSection>
);

export default FavoriteTracksList;
